// extracted by mini-css-extract-plugin
export default {"title":"_3o8K","disabled":"_3zWu"};